/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { LockOutlined } from "@mui/icons-material";
import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from '../context/AlertContext';
import { AuthContext } from './AuthContext'; // Import the AuthContext

function Login() {
  const { currentUser, signInWithGoogle , loding, userJamasp } = useContext(AuthContext); // Use the AuthContext
  const { addAlert } = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    if (loding) {
      // maybe trigger a loading screen
      return;
    }
    if (currentUser) {
      console.log("currentUser: %o", currentUser);
      console.log("userJamasp: %o", userJamasp);
      if (userJamasp?.claims?.admin) {
        addAlert("success", "You are now logged in as an admin");
        navigate("/admin/dashboard");
      }
      addAlert("success", "You are now logged in");
      navigate("/user/home");
    }
  }, [addAlert, currentUser, loding, navigate, userJamasp]);

  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlined />
      </Avatar>
      <Typography component="h1" variant="h5">
        Sign in
      </Typography>
      <Box sx={{ mt: 1 }}>
        <Button
          onClick={signInWithGoogle} // Use the signInWithGoogle function from the AuthContext
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Google Sign In
        </Button>
      </Box>
    </Box>
  );
}
export default Login;